import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { api } from '@/utils/api';

const FIELDS = [
  ['purchase_price', 'Purchase price $'], ['rehab_budget', 'Rehab / construction budget $'], ['arv', 'After-repair value $'],
  ['property_value', 'As-is value $'], ['investor_experience', 'Completed projects (36 mo)'], ['liquidity', 'Verified liquidity $'], ['fico', 'Exact FICO'],
];

// Optional deal inputs (merged into the shared lead scenario used by pricing) that unlock LTC / LTARV / experience / liquidity checks.
export const LeadScenarioForm = ({ lead, onSaved }) => {
  const [form, setForm] = useState(() => Object.fromEntries(FIELDS.map(([k]) => [k, lead.scenario?.[k] ?? ''])));
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const scenario = Object.fromEntries(Object.entries(form).filter(([, v]) => v !== '' && v != null).map(([k, v]) => [k, Number(String(v).replace(/[^0-9.]/g, ''))]));
      await api.put(`/leads/${lead.lead_id}/scenario`, scenario);
      toast.success('Deal inputs saved — re-running matching');
      onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); } finally { setSaving(false); }
  };

  const filled = FIELDS.filter(([k]) => form[k] !== '' && form[k] != null).length;
  return (
    <div className="border rounded-lg p-2 text-xs" data-testid="lead-scenario-form">
      <button type="button" className="text-primary" onClick={() => setOpen(!open)} data-testid="lead-scenario-toggle">
        {open ? 'Hide' : 'Edit'} deal inputs ({filled}/{FIELDS.length} provided) — needed for LTC, ARV, experience and liquidity checks
      </button>
      {open && (
        <div className="mt-2 space-y-2">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {FIELDS.map(([k, l]) => (
              <div key={k}><label className="text-muted-foreground">{l}</label><Input className="h-7 text-xs" value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`scenario-${k}`} /></div>
            ))}
          </div>
          <Button size="sm" onClick={save} disabled={saving} data-testid="scenario-save-btn">{saving ? 'Saving…' : 'Save & re-run matching'}</Button>
        </div>
      )}
    </div>
  );
};

export default LeadScenarioForm;
